import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { tss } from 'tss-react';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import COLOR from 'enums/COLOR';
import useTranslation from 'hooks/useTranslation';

export type Data = {
	title: string;
	count: number;
};

interface IProps {
	icon: IconDefinition;
	title: string;
	data: Data[];
}

const InfoList = (props: IProps) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div className={classes.container}>
			<h3 className={classes.h3}>
				<FontAwesomeIcon icon={props.icon} className={classes.icon} /> {props.title}
			</h3>
			<div className={classes.list}>
				<RenderIf condition={!props.data.length}>
					<div style={{ margin: '0.6rem 1rem', fontStyle: 'italic' }}>
						{t('shoppingCart:NO_INGREDIENTS')}
					</div>
				</RenderIf>
				<RenderIf condition={Boolean(props.data.length)}>
					{props.data.map((e, i) => {
						return (
							<div className={classes.item} key={i}>
								<div className={classes.title}>{e.title}</div>
							</div>
						);
					})}
				</RenderIf>
			</div>
		</div>
	);
};

export default InfoList;

export const useStyles = tss.create({
	container: {},
	list: {
		overflowY: 'auto',
		height: '30rem',
		backgroundColor: 'white',
	},
	icon: {
		marginRight: '2px',
	},
	h3: {
		fontSize: '1.1em',
		fontWeight: 'bold',
	},
	item: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		border: '1px solid #ddd',
		padding: '10px 20px',
		marginTop: '-1px',
		'&:first-of-type': {
			marginTop: '0px',
		},
	},
	title: {},
	count: {
		backgroundColor: COLOR.PRIMARY,
		display: 'flex',
		alignItems: 'center',
		height: '22px',
		padding: '0px 8px',
		fontSize: '0.8em',
		color: 'white',
	},
});
